// NOTE: This Animation component purpose is ONLY to make a showcase for the mixins animation been used, not for any component usage under Aloha project.
import React, { useRef } from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';

import { EMPTY_FUNCTION } from '@travel/traveler-core/constants';

import styles from './animation.module.scss';

import type { ReactNode } from 'react';
export type TimeOut = {
  enter: number;
  exit: number;
};

export type AnimationDuration = 'short' | 'long' | 'animation';

export type AnimationType =
  | 'fadeIn'
  | 'slideUp'
  | 'slideInRight'
  | 'fadeInDown'
  | 'shake'
  | 'zoomIn';

export type Props = {
  classNames?: string;
  wrapperClassName?: string;
  /** When this becomes true, element will appear*/
  isAppear?: boolean;

  /** When this becomes true, element will disappear*/
  isExit?: boolean;

  /** When this becomes true, transition starts*/
  isStartAction?: boolean;

  /** Timeout for entering and exiting of the animation*/
  timeout?: TimeOut;

  /** Types of the animation available*/
  type?: AnimationType;

  /** Types of basic animation*/
  animationDuration?: AnimationDuration;

  /** Reference to make a animation between the min and max threshold*/
  children: ReactNode;

  /** This will be called right after startAction becomes true*/
  onEnter?: () => void;

  /** This will be called after onEnter*/
  onEntered?: () => void;

  /** This will be called after startAction becomes false*/
  onExited?: () => void;
};

const DEFAULT_TIMEOUT = {
  enter: 300,
  exit: 300,
};

export default function Animation(props: Props) {
  const {
    isAppear = false,
    timeout = DEFAULT_TIMEOUT,
    isStartAction = true,
    children,
    onEntered = EMPTY_FUNCTION,
    onExited = EMPTY_FUNCTION,
    onEnter = EMPTY_FUNCTION,
    isExit = true,
    type = 'fadeIn',
    animationDuration = 'long',
    wrapperClassName,
    ...rest
  } = props;

  const nodeRef = useRef<null>(null);

  const classNames = {
    appear: styles[`${type}Appear`],
    appearActive: styles[`${type}AppearActive${animationDuration}`],
    enter: styles[`${type}Enter`],
    enterActive: styles[`${type}EnterActive${animationDuration}`],
    exit: styles[`${type}Exit`],
    exitActive: styles[`${type}ExitActive${animationDuration}`],
  };

  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={isStartAction}
      appear={isAppear}
      exit={isExit}
      timeout={timeout}
      classNames={Object.keys(classNames).length === 0 ? rest.classNames : classNames}
      onEntered={onEntered}
      onExited={onExited}
      onEnter={onEnter}
      unmountOnExit
      {...rest}
    >
      {/*extra div needed by CSSTransition React component, since it is expecting a element for a return value*/}
      <div ref={nodeRef} className={wrapperClassName}>
        {children}
      </div>
    </CSSTransition>
  );
}
